module.exports = __webpack_public_path__ + "img/scene-75.05f23f24.png";